var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},_vm._l((_vm.shopImg),function(item,i){return _c('div',{key:i,staticClass:"adv-img"},[_c('img',{attrs:{"src":item.image,"alt":""}})])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }